import AppPage from 'web-common/utilities/AppPage'
import {Box, styled} from '@mui/material'
import HeroSection from './components/HeroSection'
import WhyUsSection from './components/WhyUsSection'
import StepsSesction from './components/StepsSesction'
import FooterSection from './components/FooterSection'
import SectionDivider from './components/SectionDivider'

const MainContainer = styled(Box)(({theme}) => ({
  overflowX: 'hidden',
  backgroundColor: theme.palette.common.white
}))

interface HomeViewProps {}

interface HomeViewState {}

class HomeView extends AppPage<HomeViewProps, HomeViewState> {
  static path = '/'

  title = 'Home'

  render() {
    return (
      <MainContainer>
        <HeroSection />
        <SectionDivider />
        <WhyUsSection />
        <SectionDivider flipped />
        <StepsSesction />
        <SectionDivider />
        <FooterSection />
      </MainContainer>
    )
  }
}

export default HomeView.exportDefault()
